export enum DeploymentEnv {
  local = 'local',
  develop = 'develop',
  staging = 'staging',
  preprod = 'preprod',
  production = 'production',
}
